import React from 'react';
import CreateIconComponent, { CreateIconComponentProps } from '../CreateIconComponent';

export const DownloadIcon = ({
  title = 'Download',
  ...props
}: CreateIconComponentProps): JSX.Element => (
  <CreateIconComponent title={title} viewBox="0 0 32 38" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32 35.258a2 2 0 01-2 2H2l-.15-.006A2 2 0 012 33.258h28l.15.005A2 2 0 0132 35.258zm-4.333-15.625a2 2 0 00-2.71-2.939l-.109.101-6.598 6.553-.255-21.372a2 2 0 00-3.996-.102l-.004.15.254 21.213-6.485-6.442a2 2 0 00-2.72-.092l-.109.102a2 2 0 00-.092 2.72l.102.109 11.36 11.282 11.362-11.282z"
    />
  </CreateIconComponent>
);

export default DownloadIcon;
